/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BreakReportsRow,
    BreakReportsRowFromJSON,
    BreakReportsRowFromJSONTyped,
    BreakReportsRowToJSON,
} from './';

/**
 * 休憩リポートリスト
 * @export
 * @interface BreakReportsList
 */
export interface BreakReportsList {
    /**
     * 
     * @type {Array<BreakReportsRow>}
     * @memberof BreakReportsList
     */
    breaks?: Array<BreakReportsRow>;
}

export function BreakReportsListFromJSON(json: any): BreakReportsList {
    return BreakReportsListFromJSONTyped(json, false);
}

export function BreakReportsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreakReportsList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'breaks': !exists(json, 'breaks') ? undefined : ((json['breaks'] as Array<any>).map(BreakReportsRowFromJSON)),
    };
}

export function BreakReportsListToJSON(value?: BreakReportsList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'breaks': value.breaks === undefined ? undefined : ((value.breaks as Array<any>).map(BreakReportsRowToJSON)),
    };
}


